import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { resetStore, useAppDisPatch } from '../../redux/store';
import { ACCOUNT, SIGNIN } from '../../routes/routeConstants';

const useOnLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();

  const logoutUser = () => {
    const onSuccess = () => {
      toast.success('Signed Out');
      localStorage.removeItem('authData');

      // Reset entire Redux store globally
      dispatch(resetStore());

      navigate(`${ACCOUNT}/${SIGNIN}`);
    };

    onSuccess();
  };

  return { logoutUser };
};

export default useOnLogout;
